import React, { Fragment } from "react";
import { MessageDescriptor, useIntl } from "react-intl";
import { Icon } from "@tabler/icons-react";
import { classNames } from "@ct-react/core";
import "./checkout-stepper.scss";

type CheckoutStepperProps = {
  className?: string;
  steps: { icon: Icon, msg: MessageDescriptor }[];
  activeIndex?: number;
}

const CheckoutStepper = (
  {
    className,
    steps,
    activeIndex = 0,
  }: CheckoutStepperProps) => {

  const intl = useIntl();
  const wrapperClasses = classNames("r-stepper-wrapper", className);

  return (<div className={wrapperClasses}>
    {steps.map(({ icon: Icon, msg }, i) => (
      <Fragment key={i}>
        {i > 0 && <div className={classNames("connector", { selected: i + 1 <= activeIndex })} />}
        <div className={classNames("one-step", { selected: i < activeIndex })}>
          <span className="badge"><Icon /></span>
          <span className="label">{intl.formatMessage(msg)}</span>
        </div>
      </Fragment>
    ))}
  </div>);

}

export default CheckoutStepper;
